export function forwardDispatch(event, element) {
    const newEvent = new Event(event.type, {
        bubbles: event.bubbles,
        cancelable: event.cancelable,
        composed: event.composed,
    });

    element.dispatchEvent(newEvent);
}
